
"use client";

import { useAuth } from "@/contexts/auth-context";
import { AICoach } from "@/components/ai-coach";
import type { SleepEvent, Child, SleepGoal } from "@/lib/types";

interface AICoachTabProps {
  events: SleepEvent[];
  child?: Child;
  goal?: SleepGoal;
  onGoalChange?: (newGoal: Partial<SleepGoal>) => Promise<void>;
}

export function AICoachTab({ events, child, goal, onGoalChange }: AICoachTabProps) {
  const { isSubscribed } = useAuth();

  if (!child) {
    return (
      <div className="flex flex-1 items-center justify-center rounded-lg min-h-[400px] p-4">
        <div className="flex flex-col items-center gap-2 text-center">
          <h3 className="text-2xl font-bold tracking-tight">AI Coach</h3>
          <p className="text-sm text-muted-foreground">
            Please select a child to start chatting with the AI coach.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col h-full">
      <AICoach events={events} child={child} goal={goal} isSubscribed={isSubscribed} onUpdateGoal={onGoalChange} />
    </div>
  );
}
